/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label } from "reactstrap";

import briefcaseSVG from "../assets/svg/briefcase.svg";
import buildingSVG from "../assets/svg/building.svg";
import personSVG from "../assets/svg/person.svg";
import personKeySVG from "../assets/svg/person-key.svg";
import routerSVG from "../assets/svg/router.svg";

import routerImage from "../assets/images/mikrotik-router.png";

export const itemIconClassName = (type) => {
  switch (type) {
    case "client":
      return "briefcase-fill";
    case "location":
      return "building-fill";
    case "router":
      return "router-fill";
    case "captive-portal":
      return "box-arrow-in-right";
    case "account":
      return "person-fill";
    case "template":
      return "layout-wtf";
    case "marketing":
      return "megaphone-fill";
    default: return "square";
  };
};

export const itemSvgClassName = (type) => {
  switch (type) {
    case "client": return briefcaseSVG;
    case "location": return buildingSVG;
    case "account": return personSVG;
    case "accounts": return personKeySVG;
    case "router": return routerSVG;
    default: return null;
  }
};

export const itemImageClassName = (type) => {
  switch (type) {
    case "router":
      return routerImage;
    default: return null;
  };
};

export const ItemIcon = ({className, override, type}) => (
  <i className={`${className} icon bi bi-${override ?? itemIconClassName(type)}`} />
);

export const ItemImageLabel = (props) => {
  const { image, type, children, online } = props;
  return (
    <Label {...props}>
      {online}
      <img src={image} alt={type} style={{ height: "1em" }} />
      {' '}<span>{children}</span>
    </Label>
  );
};

export const ItemSvgLabel = (props) => {
  const {svg, children} = props;
  <Label {...props}>
    <img src={svg} alt="" style={{ height: "1em" }} />
    {' '}{children}
  </Label>
}

export const ItemIconLabel = (props) => {
  const {type, icon, children, online} = props;
  return (
    <Label {...props}>
      {online}
      <ItemIcon type={type} override={icon} />
      {' '}{children}
    </Label>
  );
};

const ItemLabel = (props) => {
  const {type, icon, svg, image, children, online} = props;

  const itemImage = image ?? itemSvgClassName(svg) ?? itemImageClassName(type);
  if (image || (!icon && itemImage)) {
    const itemImageProps = { ...props, image: itemImage };
    return <ItemImageLabel {...itemImageProps}>{children}</ItemImageLabel>;
  }

  return <ItemIconLabel {...props}>{children}</ItemIconLabel>;
};

export default ItemLabel;
